import { loadConnectAndInitialize } from "@stripe/connect-js";

export default ({ params, fetchClientSecret, init, ...props }) => {
    let instance = null;

    return {
        ...props,
        getStripe() {
            return instance;
        },
        initStripe() {
            instance = loadConnectAndInitialize({
                // This is your test publishable API key.
                publishableKey: import.meta.env.VITE_STRIPE_KEY,
                fetchClientSecret: fetchClientSecret,
                appearance: {
                    variables: {
                        colorPrimary: "#000000",
                    },
                },
                ...params,
            });
        },
        init() {
            init?.bind(this)();
        },
    };
};
